export enum UserRole {
    SystemAdministrator = 1,
    PortalAdministrator = 2,
    PortalSuperUser = 3,
    PortalUser = 4,
}
